module.exports = MaterialUI.Table;